import React, { useContext, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import API_URL from "@/constant/api.config";
import errorMessages from "@/constant/errorMessages";
import { property } from "@/App";
import Button from "@/components/Button";
import RadioButtonField from "@/components/RadioButtonField";
import { includes, size, isEmpty, trim } from "lodash";
import DropDown from "@/components/DropDown";
import CreatableSelect from "react-select/creatable";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import ReCAPTCHA from "react-google-recaptcha";
import { showSuccessMessage, showErrorMessage, buildPath } from "@/utils/common";
import { ToastContainer } from "react-toastify";
import regExp from "@/constant/regExpressions";
import defaultValues from "@/constant/defaultValues";
import { useAuth } from "@/AuthProvider";
import { privateRoutePaths } from "@/routes/private.route.config";
import roles from "@/constant/roles.config";
import "react-phone-number-input/style.css";
import ToolipsCustom from "@/components/ToolipsCustom";
import { publicRoutePaths } from "@/routes/public.routes.config";
import ConsentManager from "@/modules/frontend/components/ConsentManager";
import { getIPAndLocation } from "@/api/dictionaryAPI";
import { onboardingRoutePaths } from "@/routes/onboarding.route.config";
import AeroPlane from "@/assets/images/webp/aeroplane-thumb.webp";
import { loginAction } from "@/actions/loginAction";


const STORAGE_KEY = "otpEndTime";
const COUNTDOWN_SECONDS = 120;


function Index(props) {

  const { logined, user, isSuperAdmin, isPreKYCUser, isDemoUser, isEndUser, isViewer } = useAuth();

  const nav = useNavigate();
  const location = useLocation();
  const [ipData, setIPData] = useState(null);
  const { PASSWORD_FIELD_MAX_LENGTH, EMAIL_FIELD_MAX_LENGTH, IGNORE_EMAILS } = defaultValues;
  const { account, compney, compnytext } = useContext(property);
  const [isButtonDisabled, setisButtonDisabled] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [cityList, setCityList] = useState([]);
  const [phoneValue, setphoneValue] = useState();
  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [industries, setIndustries] = useState([]);
  const [selectedIndustry, setSelectedIndustry] = useState(null);
  const [countryCode, setSelectedCountryCode] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [verrors, setVErrors] = useState({});
  const [recaptchaValue, setRecapchaValue] = useState(null);
  const [isPswdVisible, setPswdVisible] = useState(false);
  const [currentIn, setCurrentIn] = useState(null);
  const [expireIn, setexpireIn] = useState(null);
  const [otpId, setOtpId] = useState(null);
  const [mailStatus, setMailStatus] = useState(false);
  const recaptchaRef = useRef(null);
  const [hideDiv, setHideDiv] = useState(false);
  const [otpButton, setOtpButton] = useState(false);
  const [timeLeft, setTimeLeft] = useState(COUNTDOWN_SECONDS);
  const [placehoderTxt, setPlaceHoderTxt] = useState("At least one alphabet letter, one digit, Minimum of 8 characters total");
  const [flag, setFlag] = useState(0);

  const isV2 = location.pathname.includes(publicRoutePaths.REGISTRATION_V2.path);

  React.useEffect(() => {
    if (account && account[0]) {
      account[0].style.border = "1px solid #0b4471";
      account[0].style.borderTopLeftRadius = "6px";
      account[0].style.borderTopRightRadius = "6px";
      account[0].style.backgroundColor = "#0b4471";
    }

    if (compney && compney[0]) {
      compney[0].style.color = "white";
    }

    if (compnytext && compnytext[0]) {
      compnytext[0].style.color = "white";
    }
  }, [account, compney, compnytext]);

  const shipmentModeOption = [
    // { label: "Select shipment mode", value: "" },
    { label: "Import", value: "Import" },
    { label: "Export", value: "Export" },
    { label: "Logistic Partner", value: "Logistic Partner" },
    { label: "Trader", value: "Trader" },
    { label: "Manufacturer", value: "Manufacturer" },
  ];

  const [formData, setFormData] = useState({
    company_name: "",
    sal: "Mr",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    industry: "",
    shipment_mode: "",
    trade_mode_type: "BUYER",
    website: "",
    country_id: "",
    city_id: "",
    inquiry_message: "",
    isNewVal: false,
    password: "",
    otp: "",
    otpId: "",
    expire_in: "",
    recapchVal: "",
    other_industry:"",
  });

  const handleSelutation = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        sal: e.target.value,
      };
    });
  };

  const [shipment_mode, setShipmentMode] = useState(null);


  useEffect(() => {
    if (industries) {
      const industry = industries.find(
        (option) => option.value === formData.industry
      );
      if (industry) {
        setSelectedIndustry(industry);
      }
    }
  }, [industries]);

  const fetchCountries = async () => {
    let apiURL = API_URL + `/countries`;
    if(!isV2) {
      apiURL = API_URL + `/countries?mode=front`;
    }
    await axios
      .get(apiURL)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((country) => ({
              value: country.id,
              label: country.name,
              countryCode: country.iso2,
            }));
            setCountryList(options);
          }
        }
      })
      .catch((err) => {
        console.log("Error ========== ", err);
      });
  };

  const handleCountryChange = async (cval) => {
    if (!cval) {
      return;
    }

    setSelectedCountryCode(cval.countryCode);
    setphoneValue("");
    setCityList([]);
    const countryId = cval.value;
    setInputValue(countryId);
    setSelectedCountry(cval);
    setSelectedCity(null);
    let errorObj = { ...verrors };
    errorObj.country_id = "";
    setVErrors(errorObj);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_id: countryId,
      };
    });
    await axios
      .get(API_URL + "/cities/" + countryId)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((ct) => ({
              value: ct.id,
              label:
                ct.name + (ct.state_code ? " (" + ct.state_code + ")" : ""),
            }));
            setCityList(options);
          }
        }
      })
      .catch((err) => {
        console.log("Error ============= ", err);
      });
  };

  const handleIndustryChange = (cval) => {
    const industryId = cval.value;
    setSelectedIndustry(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        industry: industryId,
      };
    });
    let er = { ...verrors };
    er.industry = "";
    setVErrors(er);
  };

  const handleCityChange = async (ctval) => {
    if (ctval != null) {
      const cityId = ctval.value;
      const isNew = ctval.__isNew__ ? ctval.__isNew__ : false;

      if (isNew === true) {
        if (cityId.length > 50) {
          setVErrors((prev) => ({
            ...prev,
            city_id: errorMessages.MAX_LENGTH_50_EXCEEDED,
          }));

        } else {
          setVErrors((prev) => ({
            ...prev,
            city_id: null,
          }));
        }
      } else {
        setVErrors((prev) => ({
          ...prev,
          city_id: null,
        }));
      }

      setSelectedCity(ctval);
      setFormData((prevalue) => ({
        ...prevalue,
        city_id: cityId,
        isNewVal: ctval.__isNew__ ? ctval.__isNew__ : false,
      }));
    } else {
      setSelectedCity(null);
      setVErrors((prev) => ({
        ...prev,
        city_id: null,
      }));
      setFormData((prevalue) => ({
        ...prevalue,
        city_id: null,
        isNewVal: false,
      }));
    }

  };

  const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val,
      };
    });
  };

  const handleShipmenMode = (s_mode, flag = 1) => {
    setSelectedIndustry(null);
    let trade_type = "";
    if (s_mode.value === "Import") {
      trade_type = "BUYER";
    } else if (s_mode.value === "Export") {
      trade_type = "SUPPLIER";
    } else if (s_mode.value === "Logistic Partner") {
      trade_type = "LOG_PTR";
    } else if (s_mode.value === "Trader" || s_mode.value === "Manufacturer") {
      trade_type = "BUYER";
    }
    if (flag === 0) {
      setFormData((prevalue) => {
        return {
          ...prevalue,
          shipment_mode: s_mode.value,
          industry: "",
        };
      });
    } else {
      setFormData((prevalue) => {
        return {
          ...prevalue,
          shipment_mode: s_mode.value,
          trade_mode_type: trade_type,
          industry: "",
        };
      });
    }

    let er = { ...verrors };
    er.shipment_mode = "";
    setVErrors(er);
    setShipmentMode(s_mode);
    setIndustries([]);
    setSelectedIndustry(null);
    fetchIndustryByTradeMode(s_mode.value,trade_type);
  };

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const fetchIndustryByTradeMode = async (trade_mode, trade_type = 'BUYER') => {
     const url = trade_type === 'SUPPLIER' || trade_type === 'BUYER'
      ? `${API_URL}/trading-industries/${trade_mode}/${trade_type}`
      : `${API_URL}/trading-industries/${trade_mode}`;

    await axios
      .get(url)
      .then((response) => {
        if (response.status === 200) {
          let industryList = response.data.data;
          let iList = industryList.map((val) => ({
              label: val.industy_name,
              value: val.id,
          }));

          if(trade_type === 'SUPPLIER' || trade_type === 'BUYER') {
             const otherOption = { label: "Other", value: "0" };
             setIndustries([...iList,otherOption]);
          } else {
             setIndustries([...iList]);
          }
 
        }
      })
      .catch((err) => {
        console.log("Error === ", err);
      });
  };



  const handleInputChange = (newValue) => {
    if (newValue === "" || (newValue === null && inputValue > 0)) {
      setCityList([]);
      axios
        .get(API_URL + "/cities/" + inputValue)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === true) {
              const options = response.data.data.map((ct) => ({
                value: ct.id,
                label:
                  ct.name + (ct.state_code ? " (" + ct.state_code + ")" : ""),
              }));
              setCityList(options);
            }
          }
        })
        .catch((err) => {
          console.log("Error ============= ", err);
        });
    }
    if (newValue !== "" && inputValue > 0) {
      if (newValue.length >= 3) {
        setCityList([]);
        axios
          .post(API_URL + "/cities/search", {
            search_txt: newValue,
            country_id: inputValue,
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.status === true) {
                const options = response.data.data.map((ct) => ({
                  value: ct.id,
                  label:
                    ct.name + (ct.state_code ? " (" + ct.state_code + ")" : ""),
                }));
                setCityList(options);
              }
            }
          });
      }
    }


  };

  const handleRecaptchaChange = (value) => {
    setRecapchaValue(value);
    setVErrors((prevErrors) => ({
      ...prevErrors,
      recaptcha: value ? "" : "Please complete the reCAPTCHA!",
    }));

    setFormData((prevForm) => ({
      ...prevForm,
      recapchVal: value ? value : "",
    }));
  };

  const fetchCountryByIP = async () => {
    try {
      const res = await getIPAndLocation();
      setIPData(res);
      if (res?.country_code !== "") {
        const country = countryList.find(
          (item) => item.countryCode === res?.country_code);
        if (country) {
          handleCountryChange(country);
          setSelectedCountryCode(res?.country_code);
        } else {
          console.log("Country not found in list:", res);
        }
      } else {
        console.log("No country code received from IP data:", res);
      }
    } catch (err) {
      console.log("Failed to fetch IP:", err);
    }
    // await axios
    //   .get("https://ipapi.co/json")
    //   .then((response) => {
    //     if (response.status === 200) {
    //       if (response.data.country_code !== "") {
    //         const country = countryList.find(
    //           (item) => item.countryCode === response.data.country_code
    //         );
    //         if (country) {
    //           handleCountryChange(country);
    //           setSelectedCountryCode(response.data.country_code);
    //         }
    //       }
    //     } else {
    //       console.log("Something wrong ========== ", response);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log("Error ========== ", err);
    //   });
  };

  const EnableInputFields = () => {
    setHideDiv(false);
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
    setRecapchaValue(null);
  }

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    if (countryList.length > 0) {
      fetchCountryByIP();
    }
  }, [countryList]);


  const handleTradeModeTypeChange = (e, trade_mode_type) => {
    const newInputFields = { ...formData };
    if (trade_mode_type === "BUYER") {
      newInputFields["trade_mode_type"] = "BUYER";
    } else if (trade_mode_type === "SUPPLIER") {
      newInputFields["trade_mode_type"] = "SUPPLIER";
    }
    setFormData(newInputFields);
    setIndustries([]);
    setSelectedIndustry(null);
    setFormData((prevForm) => ({
      ...prevForm,
      industry: "",
    }));
    fetchIndustryByTradeMode(shipment_mode?.value,trade_mode_type);
  };

  const handleCountryFocusOut = (e) => {
    if (selectedCountry === null) {
      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`country_id`]: errorMessages.FIELD_REQUIRED,
      }));
    } else {
      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`country_id`]: "",
      }));
    }
  };

  const handleTradeModeFocusOut = () => {
    if (shipment_mode === null) {
      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`shipment_mode`]: errorMessages.FIELD_REQUIRED,
      }));
    } else {
      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`shipment_mode`]: "",
      }));
    }
  };


  const handleCompanyIndustryFocusOut = () => {
    if (selectedIndustry === null) {
      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`industry`]: errorMessages.FIELD_REQUIRED,
      }));
    } else {
      setVErrors((prevErrors) => ({
        ...prevErrors,
        [`industry`]: "",
      }));
    }
  };


  const styleError = {
    display: "block",
  };

  const validateCityInput = (inputValue) => {
    if (inputValue === "") return null;

    const validCityRegex = /^[a-zA-Z][a-zA-Z\d\s\(\)]*$/;
    let error = "";
    if (!validCityRegex.test(inputValue)) {
      error = errorMessages.IN_VALID_FIELD_FORMAT;
    }
    return error || null;
  };

  const togglePswdField = () => {
    setPswdVisible(!isPswdVisible);
  };

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  useEffect(() => {
    if (user) {
      if (user?.role_slug?.slug === "SUP_ADM") {
        nav(`/${getPrefix()}${privateRoutePaths.MANAGE_LEADS.path}`);
      } else if (user?.role_slug?.slug === "END_USER") {
        if (user?.company_status === 1) {
          nav(`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`);
        } else {
          nav(publicRoutePaths.REGISTRATION.path);
        }
      } else if (user?.role_slug?.slug === "DEMO") {
        nav(`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`);
      } else if (user?.role_slug?.slug === "VIEWER") {
        nav(`/${getPrefix()}${privateRoutePaths.PRE_KYC_DASHBOARD.path}`);
      } else if (user?.role_slug?.slug === "PRE_KYC") {
        nav(`/${getPrefix()}${buildPath(privateRoutePaths.UPDATE_COMPANY_PROFILE, { id: user.member_id })}`)
      } else {
          nav(isV2 ? publicRoutePaths.REGISTRATION_V2.path : publicRoutePaths.REGISTRATION.path);
      }
    } else {
        nav(isV2 ? publicRoutePaths.REGISTRATION_V2.path : publicRoutePaths.REGISTRATION.path);
    }
  }, [user]);


  const handleFocusOut = async (e) => {
    let er = { ...verrors };

    if (e.target.name === "first_name") {
      if (e.target.value === "") {
        er.first_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 40) {
        er.first_name = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const regExpName = regExp.name;
        const check = regExpName.test(e.target.value);
        if (check === false) {
          er.first_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.first_name = "";
        }
      }
    }

    if (e.target.name === "last_name") {
      if (e.target.value !== "") {
        if (e.target.value.length > 40) {
          er.last_name = errorMessages.MAX_LENGTH_EXCEEDED;
        } else {
          const regExpName = regExp.name;
          const check = regExpName.test(e.target.value);
          if (check === false) {
            er.last_name = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.last_name = "";
          }
        }
      } else {
        er.last_name = "";
      }
    }

    if (e.target.name === "company_name") {
      if (e.target.value === "") {
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExpCompanyName = regExp.company_name;
        const check = regExpCompanyName.test(e.target.value);
        if (check === false) {
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.company_name = "";
        }
      }
    }

    if (e.target.name === "email") {
      if (e.target.value === "") {
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = e.target.value.split("@")[1];
        const regExp0 = regExp.email;
        const check = regExp0.test(e.target.value);
        if (check === false) {
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (IGNORE_EMAILS.includes(currentEmail)) {
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.email = "";
          try {
            const response = await axios.post(API_URL + "/email/validation", {
              search_txt: e.target.value,
              type: "REGISTRATION",
            });
            if (response.data.status === true) {
              er.email = response.data.message;
            } else {
              er.email = "";
            }
          } catch (err) {
            console.log("Error ============= ", err);
          }
        }
      }
    }

    if (e.target.name === "phone") {
      let phoneValue = e.target.value.trim();
      if (!phoneValue) {
        er.phone = errorMessages.FIELD_REQUIRED;
      } else {
        let numberWithoutCountryCode = phoneValue
          .replace(/^\+(\d{1,4})\s?/, "")
          .replace(/\s/g, "");

        if (numberWithoutCountryCode.length === 0) {
          er.phone = errorMessages.FIELD_REQUIRED;
        } else if (!isValidPhoneNumber(phoneValue)) {
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        } else {
          er.phone = "";
          // try {
          //   const response = await axios.post(API_URL + "/phone/validation", {
          //     search_txt: phoneValue,
          //   });
          //   if (response.data.status === true) {
          //     er.phone = response.data.message;
          //   }
          //   if (response.data.status === false) {
          //     er.phone = "";
          //   }
          // } catch (err) {
          //   console.log("Error validating phone number:", err);
          // }
        }
      }
    }

    if (e.target.name === "website") {
      if (e.target.value !== "") {
        if (e.target.value.length > 255) {
          er.website = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          const regExpName = regExp.website_url;
          const check = regExpName.test(e.target.value);
          if (check === false) {
            er.website = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.website = "";
          }
        }
      } else {
        er.website = "";
      }
    }

    if (e.target.name === "password") {
      const value = trim(e.target.value);
      if (isEmpty(value)) {
        er.password = errorMessages.FIELD_REQUIRED;
      } else if (size(value) > PASSWORD_FIELD_MAX_LENGTH) {
        er.password = errorMessages.MAX_CHARACTERS_REACHED;
      } else if (!regExp.pswd.test(value)) {
        er.password = errorMessages.STRONG_PASSWORD;
      } else {
        er.password = "";
      }

    }

      if (e.target.name === "other_industry") {
      if (e.target.value === "") {
        er.other_industry = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        er.other_industry = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExpName = regExp.name;
        const check = regExpName.test(e.target.value);
        if (check === false) {
          er.other_industry = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.other_industry = "";
          try {
            const response = await axios.post(API_URL + "/industry/validation", {
              search_txt: e.target.value,
            });
            if (response.data.status === true) {
              er.other_industry = response.data.message;
            } else {
              er.other_industry = "";
            }
          } catch (err) {
            console.log("Error ============= ", err);
          }
        }
      }
    }

    if (recaptchaValue !== null) {
      setVErrors((prev) => ({
        ...prev,
        recaptcha: "Please complete the reCAPTCHA!",
      }));
    } else {
      setVErrors((prev) => ({
        ...prev,
        recaptcha: "",
      }));
    }

    setVErrors(er);
    return true;

  };

  const resentOtp = async () => {

    if (otpButton || timeLeft > 0) {
      return;
    }

    if (formData.email !== "" && formData.first_name) {
      setOtpButton(true);
      setMailStatus(false);
      try {
        const response = await axios.post(API_URL + "/email/resentOtp", {
          email_txt: formData.email,
          first_name: formData.first_name,
        });
        if (response.data.status === true) {
          const newEndTime = Date.now() + COUNTDOWN_SECONDS * 1000;
          localStorage.setItem(STORAGE_KEY, newEndTime);
          setTimeLeft(COUNTDOWN_SECONDS);
          setVErrors({});
          // setMailStatus(true);
          setTimeout(() => {
            setMailStatus(true); // Trigger useEffect to restart timer
          }, 0);

          setCurrentIn(response.data.data.currentTime);
          setexpireIn(response.data.data.expireIn);
          setOtpId(response.data.data.otpId);
          showSuccessMessage(response.data.message);
          setFormData((prevalue) => {
            return {
              ...prevalue,
              otp: "",
              otpId: response.data.data.otpId,
              expire_in: response.data.data.expireIn,
            };
          });
        } else {
          showErrorMessage("Something Went Wrong!!");
        }
      } catch (err) {
        console.log("Error ============= ", err);
      } finally {
        setOtpButton(false); // Reset using existing state
      }
    }
  };

  const sendOtp = async () => {
    if (otpButton) {
      return;
    }
    setOtpButton(true);
    try {
      let er = { ...verrors };
      let flag = 0;
      // First Name
      if (formData.first_name === "") {
        flag = 1;
        er.first_name = errorMessages.FIELD_REQUIRED;
      } else if (formData.first_name.length > 40) {
        flag = 1;
        er.first_name = errorMessages.MAX_LENGTH_EXCEEDED;
      } else {
        const regExpName = regExp.name;
        if (!regExpName.test(formData.first_name)) {
          flag = 1;
          er.first_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.first_name = "";
        }
      }

      // Last Name
      if (formData.last_name !== "") {
        if (formData.last_name.length > 40) {
          flag = 1;
          er.last_name = errorMessages.MAX_LENGTH_EXCEEDED;
        } else {
          const regExpName = regExp.name;
          if (!regExpName.test(formData.last_name)) {
            flag = 1;
            er.last_name = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.last_name = "";
          }
        }
      } else {
        er.last_name = "";
      }

      // Company Name
      if (formData.company_name === "" || formData.company_name === null) {
        flag = 1;
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (formData.company_name.length > 150) {
        flag = 1;
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExpName = regExp.company_name;
        if (!regExpName.test(formData.company_name)) {
          flag = 1;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.company_name = "";
        }
      }

      // Email
      if (formData.email === "") {
        flag = 1;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
        flag = 1;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = formData.email.split("@")[1];
        const regExp0 = regExp.email;
        if (!regExp0.test(formData.email)) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (IGNORE_EMAILS.includes(currentEmail)) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.email = "";
          try {
            const response = await axios.post(API_URL + "/email/validation", {
              search_txt: formData.email,
              type: "REGISTRATION",
            });
            if (response.data.status === true) {
              flag = 1;
              er.email = response.data.message;
            } else {
              er.email = "";
            }
          } catch (err) {
            console.log("Error ============= ", err);
          }
        }
      }

      // Phone
      if (
        phoneValue === undefined ||
        phoneValue === null ||
        phoneValue.trim() === ""
      ) {
        flag = 1;
        er.phone = errorMessages.FIELD_REQUIRED;
      } else {
        let numberWithoutCountryCode = phoneValue
          .replace(/^\+(\d{1,4})\s?/, "")
          .replace(/\s/g, "");
        if (numberWithoutCountryCode.length === 0) {
          flag = 1;
          er.phone = errorMessages.FIELD_REQUIRED;
        } else if (!isValidPhoneNumber(phoneValue)) {
          flag = 1;
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        } else {
          er.phone = "";
        }
      }

      // Website
      if (formData.website !== "") {
        if (formData.website.length > 255) {
          flag = 1;
          er.website = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          const regExp0 = regExp.website_url;
          if (!regExp0.test(formData.website)) {
            flag = 1;
            er.website = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.website = "";
          }
        }
      } else {
        er.website = "";
      }

      // Country
      if (formData.country_id === "" || formData.country_id === null) {
        flag = 1;
        er.country_id = errorMessages.FIELD_REQUIRED;
      } else {
        er.country_id = "";
      }

      if (formData.isNewVal === true) {
        if (formData.city_id.length > 50) {
          flag = 1;
          er.city_id = errorMessages.MAX_LENGTH_50_EXCEEDED;

        } else {
          er.city_id = "";
        }
      } else {
        er.city_id = "";
      }

      // Industry
      if (formData.industry === "") {
        flag = 1;
        er.industry = errorMessages.FIELD_REQUIRED;
      } else {
        er.industry = "";
      }

      // Shipment Mode
      if (formData.shipment_mode === "" || formData.shipment_mode === null) {
        flag = 1;
        er.shipment_mode = errorMessages.FIELD_REQUIRED;
      } else {
        er.shipment_mode = "";
      }

      if((formData.trade_mode_type === 'SUPPLIER' || formData.trade_mode_type === 'BUYER') && selectedIndustry?.label === "Other") { 

        if (formData.other_industry === "") {
          flag = 1;
          er.other_industry = errorMessages.FIELD_REQUIRED;
        } else if (formData.other_industry.length > 150) {
          flag = 1;
          er.other_industry = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const regExpName = regExp.name;
          if (!regExpName.test(formData.other_industry)) {
            flag = 1;
            er.other_industry = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.other_industry = "";
            try {
            const response = await axios.post(API_URL + "/industry/validation", {
              search_txt: formData.other_industry,
              ind_type:formData.trade_mode_type
            });
            if (response.data.status === true) {
               flag = 1;
              er.other_industry = response.data.message;
            } else {
              er.other_industry = "";
            }
          } catch (err) {
            console.log("Error ============= ", err);
          }
          }
        }

      }

      // Password
      const pwdTxt = trim(formData.password);
      if (pwdTxt === "") {
        flag = 1;
        er.password = errorMessages.FIELD_REQUIRED;
      } else if (size(pwdTxt) > PASSWORD_FIELD_MAX_LENGTH) {
        flag = 1;
        er.password = errorMessages.MAX_CHARACTERS_REACHED;
      } else if (!regExp.pswd.test(pwdTxt)) {
        flag = 1;
        er.password = errorMessages.STRONG_PASSWORD;
      } else {
        er.password = "";
      }


      if (recaptchaValue === null) {
        flag = 1;
        er.recaptcha = "Please verify the reCAPTCHA!";
      } else {
        er.recaptcha = "";
      }

      setVErrors(er);
      if (flag === 1) {
        setFlag(1);
        setOtpButton(false);
        return;
      } else {
        if (formData.email !== "" && formData.first_name) {
          try {
            formData.password = trim(formData.password);
            const response = await axios.post(API_URL + "/email/sentOtp", {
              email_txt: formData.email,
              first_name: formData.first_name,
              form_data: formData,
            });
            if (response.data.status === true) {
              setMailStatus(false);
              const newEndTime = Date.now() + COUNTDOWN_SECONDS * 1000;
              localStorage.setItem(STORAGE_KEY, newEndTime);
              setTimeLeft(COUNTDOWN_SECONDS);
              setTimeout(() => {
                setMailStatus(true); // Start/restart timer
              }, 0);
              setVErrors({});
              // setMailStatus(true);
              setCurrentIn(response.data.data.currentTime);
              setexpireIn(response.data.data.expireIn);
              setOtpId(response.data.data.otpId);
              showSuccessMessage(response.data.message);
              setFormData((prevalue) => {
                return {
                  ...prevalue,
                  otp: "",
                  otpId: response.data.data.otpId,
                  expire_in: response.data.data.expireIn,
                };
              });
              setHideDiv(true);
              setFlag(0);

            } else {
              setisButtonDisabled(false);
              const errors = { ...verrors };
              if (response.data && response.data.error) {
                if (response.data.error.company_name) {
                  errors.company_name = response.data.error.company_name;
                }
                if (response.data.error.first_name) {
                  errors.first_name = response.data.error.first_name;
                }
                if (response.data.error.last_name) {
                  errors.last_name = response.data.error.last_name;
                }
                if (response.data.error.country_id) {
                  errors.country_id = response.data.error.country_id;
                }
                if (response.data.error.email) {
                  errors.email = response.data.error.email;
                }
                if (response.data.error.phone) {
                  errors.phone = response.data.error.phone;
                }
                if (response.data.error.industry) {
                  errors.industry = response.data.error.industry;
                }
                if (response.data.error.shipment_mode) {
                  errors.shipment_mode = response.data.error.shipment_mode;
                }
                if (response.data.error.website) {
                  errors.website = response.data.error.website;
                }
                if (response.data.error.city_id) {
                  errors.city_id = response.data.error.city_id;
                }
                if (response.data.error.password) {
                  errors.password = response.data.error.password;
                }

                if (response.data.error.recapchVal) {
                  errors.recaptcha = "Please verify the reCAPTCHA!";
                }
                setVErrors(errors);
              }
            }
          } catch (err) {
            console.log("Error ============= ", err);
          }

        }
      }
    } finally {
      setOtpButton(false);
    }
  }

  const handleOtpFocusOut = async (e) => {
    let otpVal = e.target.value;
    let er = { ...verrors };
    if (e.target.value === "") {
      er.otp = errorMessages.FIELD_REQUIRED;
    } else if (!isEmpty(e.target.value)) {
      try {
        const response = await axios.post(API_URL + "/otpCheck", {
          otpId: otpId,
          otp: otpVal,
        });
        if (response.data.status === true) {
          if (response.data.message !== "valid OTP.") {
            er.otp = response.data.message;
          } else {
            er.otp = "";
          }
        } else {
          showErrorMessage("Something Went Wrong!!");
        }
      } catch (err) {
        console.log("Error ============= ", err);
      }
    } else {
      er.otp = "";
    }
    setVErrors(er);
    return true;
  }

  const handleOtpChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  }

  const validation = async () => {
    let er = { ...verrors };
    let flag = 0;
    if (formData.otp === "" || formData.otp === null) {
      flag = 1;
      er.otp = errorMessages.FIELD_REQUIRED;
    } else if (!isEmpty(formData.otp)) {
      try {
        const response = await axios.post(API_URL + "/otpCheck", {
          otpId: otpId,
          otp: formData.otp,
        });
        if (response.data.status === true) {
          if (response.data.message !== "valid OTP.") {
            flag = 1;
            er.otp = response.data.message;
          } else {
            flag = 0;
            er.otp = "";
          }
        } else {
          showErrorMessage("Something Went Wrong!!");
        }
      } catch (err) {
        console.log("Error ============= ", err);
      }
    } else {
      flag = 0;
      er.otp = "";
    }
    setVErrors(er);
    return flag;

  }


  const handleSubmit = async (e) => {
    e.preventDefault();
    setisButtonDisabled(true);
    if (flag === 0) {
      setVErrors({});
      const isValid = await validation();
      if (isValid === 0) {
        try {
          formData.password = trim(formData.password);
          await axios
            .post(API_URL + "/member/registration-detail", formData, {
              headers: {
                Accept: "application/json",
              },
              timeout: 10000,
            })
            .then((response) => {
              let tradeModeType = response.data?.data?.trade_mode_type;
              let memberId = response?.data?.data?.member_id;
             
              
              if (response.data.status === true) {
                let pwd = formData.password;
                let eml = formData.email;

                const initialState0 = {
                  company_name: "",
                  sal: "Mr",
                  first_name: "",
                  last_name: "",
                  email: "",
                  phone: "",
                  industry: "",
                  shipment_mode: "",
                  trade_mode_type: "BUYER",
                  website: "",
                  country_id: "",
                  city_id: "",
                  inquiry_message: "",
                  isNewVal: false,
                  password: "",
                  otp: "",
                  otpId: "",
                  expire_in: "",
                  recapchVal: "",
                  other_industry:"",
                };
                setFormData(initialState0);
                localStorage.removeItem(STORAGE_KEY);
                if (!hideDiv) {
                  recaptchaRef.current.reset();
                }
                //setisButtonDisabled(false);
                setRecapchaValue(null);
                showSuccessMessage("Registartion successfully!");

    
            if (tradeModeType === "SUPPLIER") {
                 props
                  .login(eml, trim(pwd), false)
                  .then((loginResponse) => {
                    if (loginResponse.status === true) {
                      const loginData = loginResponse.data;

                      localStorage.removeItem("token");
                      localStorage.removeItem("user");
                      localStorage.setItem("token", loginData.token);
                      localStorage.setItem("user", JSON.stringify(loginData));

                      setTimeout(() => logined(loginData), 1000);

                      const routeTemplate = onboardingRoutePaths.STEPPER_FORM.path;
                      const resolvedPath = routeTemplate.replace(
                        ":id",
                        loginData.member_id || memberId
                      );
                      const finalPath = resolvedPath.startsWith("/onboarding")
                        ? resolvedPath
                        : `/onboarding${resolvedPath}`;

                      console.log("Navigating to onboarding:", finalPath);
                      nav(finalPath, { replace: true });
                    } else {
                      console.log("login response failed", loginResponse);
                      setisButtonDisabled(false);
                    }
                  })
                  .catch((error) => {
                    console.error("Error during post-registration login:", error);
                    setisButtonDisabled(false);
                  });
                } else {
                  setTimeout(() => {
                    nav(publicRoutePaths.LOGIN.path);
                  }, 500);
                }

              } else {
                setHideDiv(false);
                setisButtonDisabled(false);
                const errors = {};
                if (response.data && response.data.error) {
                  if (response.data.error.company_name) {
                    errors.company_name = response.data.error.company_name;
                  }
                  if (response.data.error.first_name) {
                    errors.first_name = response.data.error.first_name;
                  }
                  if (response.data.error.last_name) {
                    errors.last_name = response.data.error.last_name;
                  }
                  if (response.data.error.country_id) {
                    errors.country_id = response.data.error.country_id;
                  }
                  if (response.data.error.email) {
                    errors.email = response.data.error.email;
                  }
                  if (response.data.error.phone) {
                    errors.phone = response.data.error.phone;
                  }
                  if (response.data.error.industry) {
                    errors.industry = response.data.error.industry;
                  }
                  if (response.data.error.shipment_mode) {
                    errors.shipment_mode = response.data.error.shipment_mode;
                  }
                  if (response.data.error.website) {
                    errors.website = response.data.error.website;
                  }
                  if (response.data.error.city_id) {
                    errors.city_id = response.data.error.city_id;
                  }
                  if (response.data.error.password) {
                    errors.password = response.data.error.password;
                  }
                  if (response.data.error.otp) {
                    errors.otp = response.data.error.otp;
                  }
                  setVErrors(errors);
                }
              }

            })
            .catch((error) => {
              setRecapchaValue(null);
              setisButtonDisabled(false);
              console.error("Error fetching data:", error);
            });
        } catch (err) {
          setisButtonDisabled(false);
          console.error(err);
        }
      } else {
        setisButtonDisabled(false);
      }
    } else {
      setisButtonDisabled(false);
      return true;
    }
  };

  // useEffect(() => {
  //   if (mailStatus) {
  //     let savedEndTime = localStorage.getItem(STORAGE_KEY);
  //     let endTime;

  //     if (savedEndTime) {
  //       endTime = parseInt(savedEndTime, 10);
  //     } else {
  //       endTime = Date.now() + COUNTDOWN_SECONDS * 1000;
  //       localStorage.setItem(STORAGE_KEY, endTime);
  //     }

  //     const interval = setInterval(() => {
  //       const now = Date.now();
  //       const remaining = Math.floor((endTime - now) / 1000);

  //       if (remaining <= 0) {
  //         clearInterval(interval);
  //         setTimeLeft(0);
  //         localStorage.removeItem(STORAGE_KEY);
  //       } else {
  //         setTimeLeft(remaining);
  //       }
  //     }, 1000);

  //     return () => clearInterval(interval);
  //   }
  // }, [mailStatus]);
  useEffect(() => {
    if (!mailStatus) return;

    let interval;

    const startTimer = () => {
      const savedEndTime = localStorage.getItem(STORAGE_KEY);

      if (savedEndTime) {
        const endTime = parseInt(savedEndTime, 10);

        interval = setInterval(() => {
          const now = Date.now();
          const remaining = Math.floor((endTime - now) / 1000);

          if (remaining <= 0) {
            clearInterval(interval);
            setTimeLeft(0);
            localStorage.removeItem(STORAGE_KEY);
          } else {
            setTimeLeft(remaining);
          }
        }, 1000);
      }
    };

    startTimer();

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [mailStatus]);


  const formatTime = (seconds) => {
    const min = String(Math.floor(seconds / 60)).padStart(2, "0");
    const sec = String(seconds % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  console.log("=== formData.trade_mode_type ===",formData.trade_mode_type);
  return (<>
    <section className="registration-wrape">
      <SeoHelmet
        title={seoConfig.registration.title}
        description={seoConfig.registration.description}
        keywords={seoConfig.registration.keywords}
        author={seoConfig.registration.author}
      />
      <div className="container">
        <div className="row">
          <div className="col-xxl-6 col-xl-6 col-lg-2 col-md-1 col-sm-12 stat-wrapes"></div>

          <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-10 col-sm-12">
            <div className="form-wrape">
              <div className="form-pad">
                <div className="section-head">
                  <div className="head">
                    <h2 className="">Company Registration</h2>
                    {(
                      <p>
                        Register your company and verify your profile to access a global network of buyers, suppliers and logistic providers.
                      </p>
                    )}
                  </div>
                  <img src={AeroPlane} alt="Aero Plane" className="head-thumb" />
                </div>

                <form id="account-detail" onSubmit={handleSubmit}>
                  {/* <div className={hideDiv ? "row custom-display-none" : "row"}> */}
                  <div className="row">
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.first_name ? 'error-show' : ''}`}>
                        <div className="input-pad split">
                          <span className="input-group-addon">
                            <select
                              name="sal"
                              onChange={handleSelutation}
                              value={formData.sal}
                              disabled={hideDiv ? true : false}
                            >
                              <option value="Mr">Mr</option>
                              <option value="Mrs">Mrs</option>
                              <option value="Miss">Miss</option>
                            </select>
                          </span>
                          <input
                            type="text"
                            name="first_name"
                            className="input"
                            autoComplete="new-off"
                            placeholder="Enter first name *"
                            onChange={handleChange}
                            onBlur={handleFocusOut}
                            value={formData.first_name}
                            disabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.first_name && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.first_name}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.last_name ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <input
                            type="text"
                            name="last_name"
                            id="last_name"
                            className="input"
                            autoComplete="off"
                            placeholder="Enter last name"
                            onChange={handleChange}
                            onBlur={handleFocusOut}
                            value={formData.last_name}
                            disabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.last_name && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.last_name}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.country_id ? 'error-show' : ''}`}>
                        <div className="input-pad select-wrape">
                          <Select
                            name="country_id"
                            options={countryList}
                            value={selectedCountry}
                            onChange={handleCountryChange}
                            placeholder="Select country *"
                            classNamePrefix={"creatable_react_select"}
                            noOptionsMessage={() => "No Country Found"}
                            onFocus={handleCountryFocusOut}
                            className="select"
                            isDisabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.country_id && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.country_id}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.city_id ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <CreatableSelect
                            isClearable
                            name="city_id"
                            onChange={handleCityChange}
                            onInputChange={handleInputChange}
                            options={cityList}
                            value={selectedCity}
                            classNamePrefix={"creatable_react_select"}
                            placeholder="Enter city"
                            formatCreateLabel={(inputValue) => {
                              const validationError = validateCityInput(inputValue);
                              if (validationError || isEmpty(inputValue)) {
                                return;
                              }
                              return `Create "${inputValue}"`;
                            }}
                            isValidNewOption={(inputValue) =>
                              validateCityInput(inputValue) === null
                            }
                            isDisabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.city_id && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.city_id}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.phone ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <PhoneInput
                            id="contact-form-phone"
                            className="input"
                            name="phone"
                            international
                            limitMaxLength
                            placeholder="Enter contact *"
                            defaultCountry={countryCode}
                            value={phoneValue}
                            onChange={handlePhoneChange}
                            onBlur={handleFocusOut}
                            autoComplete="off"
                            disabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.phone && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.phone}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.company_name ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <input
                            type="text"
                            name="company_name"
                            id="company_name"
                            className="input"
                            onChange={handleChange}
                            autoComplete="off"
                            placeholder="Enter company name *"
                            onBlur={handleFocusOut}
                            value={formData.company_name}
                            disabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.company_name && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.company_name}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.website ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <input
                            type="text"
                            name="website"
                            id="website"
                            className="input"
                            autoComplete="off"
                            placeholder="Enter website"
                            onChange={handleChange}
                            onBlur={handleFocusOut}
                            value={formData.website}
                            disabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.website && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.website}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.shipment_mode ? 'error-show' : ''}`}>
                        <div className="input-pad select-wrape">
                          <DropDown
                            placeholder={"Select trade mode *"}
                            options={shipmentModeOption}
                            onChange={handleShipmenMode}
                            value={shipment_mode}
                            name="shipment_mode"
                            id="shipment_mode"
                            noOptionsMessage={() => "No Trade Mode Found"}
                            onFocus={handleTradeModeFocusOut}
                            isDisabled={hideDiv ? true : false}
                          />
                        </div>
                        <div className="d-flex">
                          {verrors.shipment_mode && (
                            <div className="invalid-feedback" style={styleError}>
                              {verrors.shipment_mode}
                            </div>
                          )}

                          {includes(
                            ["Trader", "Manufacturer"],
                            formData.shipment_mode
                          ) && (
                              <>
                                <div className="r-buttn">
                                  <label className="">
                                    <RadioButtonField
                                      onChange={(e) =>
                                        handleTradeModeTypeChange(e, "BUYER")
                                      }
                                      checked={formData.trade_mode_type === "BUYER"}
                                      disabled={hideDiv ? true : false}
                                    /> Buyer</label>
                                </div>
                                <div className="r-buttn">
                                  <label className="">
                                    <RadioButtonField
                                      onChange={(e) =>
                                        handleTradeModeTypeChange(e, "SUPPLIER")
                                      }
                                      checked={formData.trade_mode_type === "SUPPLIER"}
                                      disabled={hideDiv ? true : false}
                                    /> Supplier</label>
                                </div>
                              </>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.industry ? 'error-show' : ''}`}>
                        <div className="input-pad select-wrape">
                          <Select
                            name="industry"
                            options={industries}
                            value={selectedIndustry}
                            onChange={handleIndustryChange}
                            placeholder="Select industry *"
                            classNamePrefix={"creatable_react_select"}
                            noOptionsMessage={() => "No Company Industry Found"}
                            onFocus={handleCompanyIndustryFocusOut}
                            isDisabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.industry && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.industry}
                          </div>
                        )}
                      </div>
                    </div>

                     {selectedIndustry && selectedIndustry?.label == 'Other' && 
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                         
                          <div className={`input-wrape`}>
                              <div className="input-pad">
                                <input
                                  type="text"
                                  name="other_industry"
                                  id="other_industry"
                                  className="input"
                                  autoComplete="off"
                                  placeholder="Enter your industry*"
                                  onChange={handleChange}
                                  onBlur={handleFocusOut}
                                  value={formData.other_industry}
                                  disabled={hideDiv ? true : false}
                                />
                              </div>
                              {verrors.other_industry && (
                                <div className="invalid-feedback" style={styleError}>
                                  {verrors.other_industry}
                                </div>
                              )}
                        
                          </div>
                     
                    </div>
                     }



                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className={`input-wrape ${verrors.email ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <input
                            type="text"
                            name="email"
                            id="email"
                            className="input"
                            autoComplete="off"
                            placeholder="Enter your email*"
                            onChange={handleChange}
                            onBlur={handleFocusOut}
                            value={formData.email}
                            disabled={hideDiv ? true : false}
                          />
                        </div>
                        {verrors.email && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.email}
                          </div>
                        )}
                      </div>
                    </div>

                    

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      
                      <div className={`input-wrape ${verrors.password ? 'error-show' : ''}`}>
                        <div className="d-flex">
                          <div className="input-pad pass">
                            <input
                              type={isPswdVisible ? "text" : "password"}
                              name="password"
                              id="password"
                              className="input"
                              autoComplete="off"
                              placeholder="Enter password *"
                              onChange={handleChange}
                              onBlur={handleFocusOut}
                              value={formData.password}
                              maxLength={PASSWORD_FIELD_MAX_LENGTH + 1}
                              disabled={hideDiv ? true : false}
                            />
                            <span
                              className="input-group-text"
                              onClick={togglePswdField}
                            >
                              <i
                                className={
                                  !isPswdVisible
                                    ? "fa-regular fa-eye"
                                    : "fa-solid fa-eye-slash"
                                }
                              ></i>
                            </span>
                          </div>
                          <ToolipsCustom
                            title={"?"}
                            subtitle={placehoderTxt}
                          >
                          </ToolipsCustom>

                        </div>
                        {verrors.password && (
                          <div className="invalid-feedback" style={styleError}>
                            {verrors.password}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-12">
                      <hr className="mt-0" />
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 registration-capch">
                      {!hideDiv && <ReCAPTCHA
                        sitekey={process.env.REACT_APP_SITE_KEY}
                        onChange={handleRecaptchaChange}
                        ref={recaptchaRef}
                        className={`registration-capch-inner`}
                        onExpired={() => {
                          setRecapchaValue(null);
                          setVErrors((prevErrors) => ({
                            ...prevErrors,
                            recaptcha: "Please complete the reCAPTCHA!",
                          }));
                          setFormData((prevalue) => ({
                            ...prevalue,
                            recapchVal: "",
                          }));
                        }}
                        onBlur={handleFocusOut}
                      />
                      }
                      {!hideDiv && verrors.recaptcha && (
                        <div className="invalid-feedback" style={styleError}>
                          {verrors.recaptcha}
                        </div>
                      )}

                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className="Sent-otp-wraper">
                        {!hideDiv && <Button
                          className="btn secondry-btn"
                          type="button"
                          onClick={sendOtp}
                          disabled={otpButton}
                        >
                          Verify Email
                        </Button>
                        }
                      </div>
                    </div>
                    {/* <hr /> */}

                    {
                      hideDiv && <>
                        <p className="light dull mb-2">You will receive an OTP on your registered email address.</p>
                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                          <div className={`input-wrape ${verrors.otp ? 'error-show' : ''} `}>
                            <div className="input-pad">
                              <input
                                type="text"
                                name="otp"
                                id="otp"
                                className="input"
                                autoComplete="off"
                                placeholder={"Enter OTP email *"}
                                onChange={handleOtpChange}
                                onBlur={handleOtpFocusOut}
                                value={formData.otp}
                                disabled={""}
                                inputMode="numeric"
                                maxLength={6}
                                pattern="[0-9]*"
                                onKeyPress={(e) => {
                                  if (!/[0-9]/.test(e.key)) e.preventDefault();
                                }}
                              />
                              {verrors.otp && (
                                <div className="invalid-feedback" style={styleError}>
                                  {verrors.otp}
                                </div>
                              )}

                              {timeLeft > 0 ? (
                                <span className="resend-otp-text">Resend OTP in: <b>{formatTime(timeLeft)}</b></span>
                              ) : (
                                <>
                                  <p></p>
                                  <button
                                    className={`${mailStatus === true ? "d-inline-block" : "d-none"} btn border-btn resend-otp`}
                                    type="button"
                                    onClick={resentOtp}
                                  >
                                    Resend OTP
                                  </button>
                                </>
                              )}

                            </div>
                          </div>
                        </div>

                        <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 inquiry-form-btn">
                          <Button
                            className="btn outline"
                            type="button"
                            onClick={EnableInputFields}
                          >
                            Back
                          </Button>
                          <Button
                            className="btn secondry-btn"
                            type="submit"
                            disabled={isButtonDisabled}>
                            Submit
                          </Button>
                        </div>
                      </>
                    }
                  </div>
                  {/* <div className={hideDiv ? "row otp-wrape" : "row otp-wrape custom-display-none"}>
                    {/* <p className="mt-4">
                      You will receive an OTP on your registered email address.
                    </p> */}
                  { /*<p className="mb-1">
                      You will receive an OTP on your registered email address.
                    </p>
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                      <div className="input-wrape">
                        <div className="input-pad">
                          <input
                            type="text"
                            name="otp"
                            id="otp"
                            className="input"
                            autoComplete="off"
                            placeholder={"OTP *"}
                            onChange={handleOtpChange}
                            onBlur={handleOtpFocusOut}
                            value={formData.otp}
                            disabled={""}
                            inputMode="numeric"
                            maxLength={6}
                            pattern="[0-9]*"
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) e.preventDefault();
                            }}
                          />
                          {verrors.otp && (
                            <div className="invalid-feedback" style={styleError}>
                              {verrors.otp}
                            </div>
                          )}

                          {timeLeft > 0 ? (
                            <span className="resend-otp-text">Resend OTP in: <b>{formatTime(timeLeft)}</b></span>
                          ) : (
                            <>
                              <p></p>
                              <button
                                className={`${mailStatus === true ? "d-inline-block" : "d-none"} btn border-btn resend-otp`}
                                type="button"
                                onClick={resentOtp}
                              >
                                Resend OTP
                              </button>
                            </>
                          )}

                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 inquiry-form-btn">
                      <Button
                        className="btn outline"
                        type="button"
                        onClick={() => nav("/")}
                      >
                        Back
                      </Button>
                      <Button
                        className="btn secondry-btn"
                        type="submit"
                        disabled={isButtonDisabled}>
                        Submit
                      </Button>
                    </div>
                  </div> */}
                </form>
              </div>
              <ToastContainer />
            </div>
          </div>
        </div>
      </div >
    </section >
    <ConsentManager data={ipData} />
  </>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.login,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    login: (email, pswd, isRememberMeChecked) =>
      dispatch(loginAction(email, pswd, isRememberMeChecked))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
